import React, { PropsWithChildren } from 'react';
import { Button, useColorModeValue } from '@cardboard-ui/react';

type EditorToolBarButtonProps = PropsWithChildren<{
  onClick(): void;
  selected?: boolean;
  isDisabled?: boolean;
  size?: string;
}>;

export const EditorToolBarButton = ({
  onClick,
  children,
  selected = false,
  isDisabled = false,
  size,
}: EditorToolBarButtonProps) => {
  const selectedBgColor = useColorModeValue(
    selected ? 'gray.200' : undefined,
    selected ? 'gray.600' : undefined,
  );

  const disabledColor = useColorModeValue(
    isDisabled ? 'gray.400' : 'gray.600',
    isDisabled ? 'gray.400' : 'gray.100',
  );

  return (
    <Button
      variant="ghost"
      onClick={onClick}
      color={disabledColor}
      bgColor={selectedBgColor}
      isDisabled={isDisabled}
      size={size}
    >
      {children}
    </Button>
  );
};
